import { render, staticRenderFns } from "./schoolManage.vue?vue&type=template&id=15451489&scoped=true&"
import script from "./schoolManage.vue?vue&type=script&lang=js&"
export * from "./schoolManage.vue?vue&type=script&lang=js&"
import style0 from "./schoolManage.vue?vue&type=style&index=0&id=15451489&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15451489",
  null
  
)

export default component.exports